import { useGlobalContext } from '../context'

function Villager() {
    const {index,players, openWaitingScreen} = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Villager)</h4>
            <p className='text-center'>You probably have the most exciting role in the game(!)You are a farming, bad smelling, poor fucking villager!
            Just don't make it obvious and pass the phone to the next player.</p>
            <img className='d-block mx-auto' src={`./img/${currentPlayer.class}.png`} alt=""/>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default Villager;